module.exports = __webpack_public_path__ + "img/img01.ce4ac0e6.svg";